import React from 'react'
import { css } from '@emotion/react'
import { object, func, string, oneOfType } from 'prop-types'

import { getDesignationLabel, getDesignationIcon } from '@/utils/products'

const designationCss =
  (variant) =>
  ({ font, colors }) =>
    css`
      display: flex;
      align-items: center;
      font-weight: ${font.bold};
      font-size: 0.625rem;
      line-height: 1.2;
      white-space: nowrap;

      span {
        display: flex;
        align-items: center;
        font-size: 12px;
      }

      svg {
        min-width: 15px;
        min-height: 15px;
        width: 15px;
        height: 15px;
        margin-bottom: 1px;
      }

      ${variant === 'card' &&
      css`
        color: ${colors.primary};
        opacity: 0.7;
        font-weight: normal;
        letter-spacing: -0.1px;

        span {
          font-size: 0.625rem;
        }
      `}
    `

const Designation = ({ product, variant, ...rest }) => {
  const designationLabel = getDesignationLabel(product)
  const designationIcon = getDesignationIcon(product)

  return (
    <div css={designationCss(variant)} {...rest} data-test="works-with">
      Works with&nbsp;
      {variant !== 'card' && <>&nbsp;{designationIcon}&nbsp;</>}
      <span>{designationLabel}</span>
    </div>
  )
}

Designation.propTypes = {
  designationCss: oneOfType([object, func]),
  product: string,
  variant: string,
}

export default Designation
